import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { rejoinMapImages as t } from "./rejoinMapImages.mjs";
import { useInfiniteListQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
import { useMemo as i } from "react";
import { canonicalZoom as a, snapBbox as o } from "@maat/utils";
//#region src/properties/useMapPropertiesListQuery.ts
var s = (s, c = !0, l = !1) => {
	let u = i(() => s && {
		...s,
		zoom: a(s.zoom),
		bbox: o(s.bbox, s.zoom)
	}, [s]);
	return n({
		queryKey: e.mapList(l ? {
			...u,
			peek: l
		} : u),
		fetchPage: async (e) => {
			let n = await r.getMapPropertiesList({
				...u,
				page: e,
				...l ? { peek: l } : {}
			});
			return {
				...n,
				hasMore: l ? !1 : n.hasMore,
				items: n.items.map((e) => t(e, n.imageBase))
			};
		},
		key: "items",
		enabled: c && !!u?.bbox,
		placeholderData: (e) => e
	});
};
//#endregion
export { s as useMapPropertiesListQuery };
